import { render } from "./DeliveryDispatch.vue?vue&type=template&id=17b3f836&scoped=true"
import script from "./DeliveryDispatch.vue?vue&type=script&lang=js"
export * from "./DeliveryDispatch.vue?vue&type=script&lang=js"

import "./DeliveryDispatch.vue?vue&type=style&index=0&id=17b3f836&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b3f836"]])

export default __exports__